import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';

type ThisApi = ApiDefinition['/creators/{creatorSlug}/members/{personId}/private-profile']['GET'];

type Props = ThisApi['params'];

const getMemberPrivateProfile = async ({ creatorSlug, personId }: Props): Promise<ThisApi['response']> => {
  const response = await noodleApiClient.get(`/creators/${creatorSlug}/members/${personId}/private-profile`);
  return response.data;
};

export default getMemberPrivateProfile;
